import { type CountryCode } from '@constants'
import { createMutationHelper } from '@utils/swr'
import { type PaymentTransactionResponse } from '../types/apiResponse'
import { type ECommerceV2Apis } from '../types/apis'

const { useMutation } = createMutationHelper<ECommerceV2Apis['get']['paymentTransaction'], PaymentTransactionResponse, { country_code: CountryCode, id: string }>({
  client: 'eCommerceV2',
  key: '/:countryCode/payment_transactions',
  fetcher: (_, { arg, client }) => {
    if (!arg.id) {
      return Promise.reject(new Error('Transaction ID is required'))
    }
    return client.get(`/${arg.country_code}/payment_transactions/${arg.id}`)
  },
})

export const useApiECommerceGetPaymentTransactionMutation = useMutation
